import React from "react";
import { Box, Skeleton, Grid } from "@mui/material";

const GallerySkeleton = () => {
  return (
    <Grid sx={{ height: "100vh", backgroundColor: "#E8E8E8" }}>
      {/* Header Skeleton */}
      <Grid
        item
        xs={12}
        sx={{
          height: "11vh",
          marginBottom: "1vh",
          backgroundColor: "#E8E8E8",
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="pulse"
          sx={{ backgroundColor: "rgba(255, 255, 255, 0.6)" }}
        />
      </Grid>

      {/* Main Content Skeleton */}
      <div
        style={{
          height: "calc(100vh - 12vh)",
          overflow: "hidden",
          backgroundColor: "#E8E8E8",
          display: "grid",
          gridTemplateColumns: "25vw 1fr",
          gridGap: 10,
          padding: "0 10px",
        }}
      >
        {/* Left Sidebar Skeleton - DataBox */}
        <Box sx={{ height: "100%" }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="pulse"
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              borderRadius: "8px",
            }}
          />
        </Box>

        {/* Right Content Skeleton */}
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {/* Top two boxes - Profile and Primary Wheel */}
          <Box sx={{ display: "flex", gap: "16px", height: "240px" }}>
            {/* Profile Box */}
            <Box sx={{ flex: 1 }}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                animation="pulse"
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "8px",
                }}
              />
            </Box>

            {/* Primary Wheel Box */}
            <Box sx={{ flex: 1 }}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                animation="pulse"
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "8px",
                }}
              />
            </Box>
          </Box>

          {/* Bottom Tabs and Content */}
          <Box sx={{ flex: 1 }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.6)",
                borderRadius: "8px",
              }}
            />
          </Box>
        </Box>
      </div>
    </Grid>
  );
};

export default GallerySkeleton;
